import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/detailedSalesMonitoringReport', request)
}

export {get}
